import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import useSound from "use-sound";
import moment from "moment";
// STYLES
import { GamePageWrapper } from "./CrossWord.style";
// COMPONENTS
import Crossword from "Components/CrossWordLibrary";
import ResetCrosswordModal from "Components/English/CrossWord/Modal/ResetCrosswordModal";
// HELPERS
import { Api, URL_ENGLISH_DASHBOARD } from "Helpers";
// REDUX
import { showToast } from "Redux/General/Actions";
import { updateGameScore, updateTotalScore } from "Redux/Auth/Actions";
// SOUNDS
import LetterSound from "Assets/Sounds/English/letterType.mp3";
import { ClueWrapper } from "Components/Civics/EscapeRoom/Room.style";
import CustomButton from "Components/Commons/CustomButton/CustomButton";

const theme = { gridBackground: "rgba(0,255,255,0)", cellBackground: "#ffea7d", cellBorder: "#503203", numberColor: "#4f1800", textColor: "rgb(0,0,0)" };

const CrosswordOpenGame = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();

    const gamesStatus = JSON.parse(localStorage.getItem("gamesStatus")) || undefined

    const profileInfo = useSelector((state) => state.Auth.profileInfo);

    const [play] = useSound(LetterSound, { volume: 0.2 });

    const [loading, setLoading] = useState(false);
    const [puzzleData, setPuzzleData] = useState({});
    const [resultLoading, setResultLoading] = useState(false);
    const [resetCrossword, setResetCrossword] = useState(false);
    const [crossWordCompleted, setCrossWordCompleted] = useState(false);
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        return function cleanup() {
            logoutStudent();
        };
    }, []); // eslint-disable-line

    useEffect(() => {
        if (Object.keys(gamesStatus).length) {
            if (gamesStatus?.isCrossWordActive) {
                const stored = localStorage.getItem("openCrosswordData");
                if (stored) {
                    try {
                        const parsed = JSON.parse(stored);
                        setPuzzleData(parsed);
                        console.log("Loaded crossword progress from localStorage");
                        return; // skip API call
                    } catch (e) {
                        console.warn("Failed to parse stored crossword data", e);
                    }
                }
                getPuzzleData(); // fallback to demo API if no local data
            } else {
                navigate(URL_ENGLISH_DASHBOARD);
            }
        }
    }, []); // eslint-disable-line

    const getPuzzleData = async (scores) => {
        if (scores) setResultLoading(true);
        else setLoading(true);

        const response = new Api().get("demoGame/crossword")

        const [puzzleDataResponse, storedPuzzleResponse] = [await response, { status: 200, data: {} }]

        console.log(storedPuzzleResponse, "storedPuzzleResponse")
        if (puzzleDataResponse.status === 200 && storedPuzzleResponse.status === 200) {
            const data = puzzleDataResponse.data;
            const storedPuzzleResponseData = storedPuzzleResponse.data;

            if (storedPuzzleResponseData && storedPuzzleResponseData?.crossWordData) {
                const parsedData = JSON.parse(storedPuzzleResponseData.crossWordData);

                localStorage.setItem("guesses", parsedData);
            } else localStorage.removeItem("guesses");

            dispatch(updateGameScore(data?.currentCrossWordScore));

            const gameCompletion = data.isCrossWordPuzzleComplete;
            const puzzle = puzzleDataResponse.data.crossWordPuzzleMap;

            setResetCrossword(false);

            const acrossQuestion = [],
                downQuestion = [],
                correctGiven = [];

            if (Object.keys(puzzle)) {
                if (puzzle?.across) {
                    const acrossData = puzzle.across;
                    const acrossList = Object.keys(acrossData);

                    acrossList.length &&
                        acrossList.forEach((item) => {
                            acrossQuestion.push({ question: acrossData[item].clue, answer: acrossData[item].answer, keyIndex: item });

                            if (acrossData[item]?.completed && acrossData[item].completed)
                                correctGiven.push({ direction: "across", number: item, answer: acrossData[item].answer, correct: acrossData[item].correct, completed: acrossData[item].completed });

                            acrossData[item].gameCompletion = gameCompletion;
                            acrossData[item].attempted = acrossData[item].attemptTime > 0 ? true : false;
                            acrossData[item].corrected = gameCompletion ? acrossData[item].correct : acrossData[item].attemptTime > 0 ? true : false;
                        });
                }

                if (puzzle?.down) {
                    const downData = puzzle.down;
                    const downList = Object.keys(downData);

                    downList.length &&
                        downList.forEach((item) => {
                            downQuestion.push({ question: downData[item].clue, answer: downData[item].answer, keyIndex: item });

                            if (downData[item]?.completed && downData[item].completed)
                                correctGiven.push({ direction: "down", number: item, answer: downData[item].answer, correct: downData[item].correct, completed: downData[item].completed });

                            downData[item].gameCompletion = gameCompletion;
                            downData[item].attempted = downData[item].attemptTime > 0 ? true : false;
                            downData[item].corrected = gameCompletion ? downData[item].correct : downData[item].attemptTime > 0 ? true : false;
                        });
                }

                const checkReset = correctGiven.every((data) => data.completed && data.correct);

                if (checkReset && gameCompletion) setResetCrossword(true);
            }

            // const questionDataList = { acrossQuestionList: acrossQuestion, downQuestionList: downQuestion };
            localStorage.removeItem("openCrosswordData");

            setPuzzleData(puzzle);
            setCrossWordCompleted(gameCompletion);
            // setCrossWordQuestions(questionDataList);

            if (scores) {
                if (gameCompletion) dispatch(updateGameScore(scores?.totalCrossWordScore));
                else dispatch(updateGameScore(scores?.currentScore));

                dispatch(updateTotalScore(scores?.totalScore));
            }
        }

        setLoading(false);
        setResultLoading(false);
    };
    console.log(puzzleData, "puzzleData")
    const logoutStudent = async () => {
        if (state && state?.schoolClassTestId && state.schoolClassTestId.length) {
            const params = { studentId: profileInfo?.id, schoolClassTestId: state.schoolClassTestId };

            const response = await new Api().get(`student/able-to-log-out`, { params });

            if (response.status === 200 || response.status === 201) {
                const data = response.data;

                if (data?.isAbleToLogOutFromCrossWord && data.isAbleToLogOutFromCrossWord) {
                    const dateTime = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
                    const payload = { type: "LOGOUT", studentId: profileInfo?.id, schoolClassTestId: state.schoolClassTestId, moduleName: "CROSSWORD", dateTime: dateTime };

                    new Api().post(`student/clock-in-clock-out`, { data: payload });
                }
            }
        }
    };

    const handleCorrect = async (direction, number, correct) => {
        try {
            setResultLoading(true);

            // defensive checks
            const dataValues = puzzleData && puzzleData[direction] && puzzleData[direction][number];
            if (!dataValues) {
                setResultLoading(false);
                return;
            }

            // Determine correctness:
            // - If `correct` is boolean, use it.
            // - If `correct` is a string (user-entered answer), compare case-insensitively with the expected answer.
            let isCorrect = false;
            if (typeof correct === "boolean") {
                isCorrect = correct;
            } else if (typeof correct === "string") {
                const entered = (correct || "").toString().trim().toUpperCase();
                const expected = (dataValues.answer || "").toString().trim().toUpperCase();
                isCorrect = entered.length > 0 && entered === expected;
            } else {
                // fallback: if library didn't provide a useful value, assume incorrect
                isCorrect = false;
            }

            // --- increment attempts (each time user submits an answer) ---
            const newAttempts = attempts + 1;
            setAttempts(newAttempts);

            // Immutable update of puzzleData
            const updatedPuzzle = { ...puzzleData };
            updatedPuzzle[direction] = { ...updatedPuzzle[direction] };
            const updatedItem = { ...updatedPuzzle[direction][number] };

            // Update fields
            updatedItem.attempted = true;
            updatedItem.completed = true;
            updatedItem.correct = isCorrect;
            // store user's answer if we received a string; otherwise preserve existing userAnswer
            if (typeof correct === "string" && correct.trim().length > 0) {
                updatedItem.userAnswer = correct;
            } else if (isCorrect) {
                // if correct but no user string provided, keep the canonical answer as userAnswer
                updatedItem.userAnswer = updatedItem.answer;
            } else {
                updatedItem.userAnswer = updatedItem.userAnswer || "";
            }

            // put item back and update state
            updatedPuzzle[direction][number] = updatedItem;
            setPuzzleData(updatedPuzzle);

            // persist progress locally
            try {
                localStorage.setItem("openCrosswordData", JSON.stringify(updatedPuzzle));
            } catch (e) {
                console.warn("Failed to save crossword progress", e);
            }
            // Scoring: award points for correct answers (example: answerLength or answer length)
            if (isCorrect) {
                const points = Number(updatedItem.answerLength) || (updatedItem.answer ? updatedItem.answer.length : 1);

                // Derive previous score: prefer profileInfo.currentCrossWordScore if present, else 0.
                const prevScore = Number(profileInfo?.currentCrossWordScore) || 0;
                const newScore = prevScore + points;

                // update redux with the new absolute score (matches how your code used updateGameScore previously)
                dispatch(updateGameScore(newScore));
            }

            // feedback toast
            if (isCorrect) dispatch(showToast("Your answer is correct!"));
            else dispatch(showToast("Your answer is incorrect!"));

            // Check completion: all across + down must be completed && correct
            const correctGiven = [];

            if (updatedPuzzle.across) {
                Object.keys(updatedPuzzle.across).forEach((k) => {
                    const it = updatedPuzzle.across[k];
                    correctGiven.push({ completed: !!it.completed, correct: !!it.correct });
                });
            }
            // there may be other directions (e.g., down / up). Check common ones
            if (updatedPuzzle.down) {
                Object.keys(updatedPuzzle.down).forEach((k) => {
                    const it = updatedPuzzle.down[k];
                    correctGiven.push({ completed: !!it.completed, correct: !!it.correct });
                });
            }
            if (updatedPuzzle.up) {
                Object.keys(updatedPuzzle.up).forEach((k) => {
                    const it = updatedPuzzle.up[k];
                    correctGiven.push({ completed: !!it.completed, correct: !!it.correct });
                });
            }

            const checkReset = correctGiven.length ? correctGiven.every((d) => d.completed && d.correct) : false;
            if (checkReset) setResetCrossword(true);

            // --- If user reached 3 attempts, show final toast and redirect to login ---
            if (newAttempts >= 3) {
                dispatch(showToast("You have used 3 attempts. Redirecting to login..."));
                // clear any demo storage as you already do in SkipToLogin
                localStorage.clear();
                // allow 1s so toast is visible, then navigate
                setTimeout(() => {
                    navigate("/login");
                }, 1000);
            }
        } catch (err) {
            // keep UI consistent on error
            console.error("handleCorrect error:", err);
        } finally {
            setResultLoading(false);
        }
    };

    const handleCloseCrossWord = () => {
        setResetCrossword(false);
        localStorage.removeItem("openCrosswordData");
    };

    const crossWordGridUI = () => <Crossword theme={theme} className="crossword" data={puzzleData} onAnswerComplete={!resultLoading && handleCorrect} onCellChange={play} />;

    const handleSkipLToLogin = () => {
        dispatch(showToast("Redirecting to the login page."));

        localStorage.clear();

        // small delay so message is visible before navigation
        setTimeout(() => {
            navigate("/login");
        }, 1000);
    }

    return (
        <GamePageWrapper>
            <div className="full-width-section">
                <div className="sub-container">
                    <div className="heading-container">
                        <div className="heading">CROSSWORD</div>
                    </div>

                    {loading ? (
                        <div className="progress">
                            <CircularProgress />
                        </div>
                    ) : (
                        <div className="game-container">
                            {Object.keys(puzzleData) && Object.keys(puzzleData).length > 0 && puzzleData?.across && puzzleData?.down && (
                                <>
                                    {resultLoading ? (
                                        <div className="overlay-table">
                                            {crossWordGridUI()}

                                            <div className="display-circular-progress">
                                                <CircularProgress className="progress" />
                                            </div>
                                        </div>
                                    ) : (
                                        crossWordGridUI()
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <ClueWrapper>
                <div className="skip-to-login">
                    <Box position="relative" display="inline-flex">
                        <CustomButton onClick={handleSkipLToLogin} text={"Skip to Login"} />
                    </Box>
                </div>
            </ClueWrapper>

            {resetCrossword && <ResetCrosswordModal open={resetCrossword} handleClose={handleCloseCrossWord} />}
        </GamePageWrapper>
    );
};

export default CrosswordOpenGame;
